<h2 mat-dialog-title>Registrar pago</h2>

<mat-dialog-content class="payment-dialog">
  <p class="payment-patient">{{ data.patientName }}</p>
  @if (registeredBy()) {
    <p class="payment-registrar">Registrado por {{ registeredBy() }}</p>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Monto</mat-label>
    <input
      matInput
      inputmode="decimal"
      [ngModel]="amount()"
      (ngModelChange)="amount.set($event)"
      [disabled]="saving()"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Fecha</mat-label>
    <input
      matInput
      type="date"
      [ngModel]="paidOn()"
      (ngModelChange)="paidOn.set($event)"
      [disabled]="saving()"
    />
  </mat-form-field>

  @if (error()) {
    <p class="payment-error" role="alert">{{ error() }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="saving()" (click)="dialogRef.close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" [disabled]="saving()" (click)="save()">
    {{ saving() ? 'Guardando…' : 'Guardar pago' }}
  </button>
</mat-dialog-actions>
